import settings from '@/settings'

const pegarPessoas = (headers, data) => {
    let url = `${settings.fisioApi}/admin/pessoas-admin/`
    if (data) {
        const keys = Object.keys(data)
        for (let i = 0; i < keys.length; i++) {
        url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
        }
    }

    return fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'default',
        headers: headers
    })
}

const editarPessoa = (headers, id_pessoa, data) => {
    return fetch(`${settings.fisioApi}/admin/pessoas-admin/?id_pessoa=${id_pessoa}`, {
        method: 'PUT',
        mode: 'cors',
        cache: 'default',
        headers: headers,
        body: JSON.stringify(data)
    })
}

export default {
    pegarPessoas,
    editarPessoa
}